import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Language = "en" | "es"

interface LanguageStore {
  language: Language
  setLanguage: (lang: Language) => void
}

export const useLanguage = create<LanguageStore>()(
  persist(
    (set) => ({
      language: "es", // Español como versión principal
      setLanguage: (language) => set({ language }),
    }),
    {
      name: 'risko-language',
    }
  )
)
